module.exports = __webpack_public_path__ + "static/media/ilmalampopumppu-black.a0d5a0e4.svg";